import type { NodeInvokeResult, NodePutData, UpdateWorkflowLogPayload } from '../../types'
import type { ExtraParams } from './helper/common'
import { getArgsResult, getRecordResult } from './helper/common'

/**
 *
 * @param code
 * @param message
 * @param data
 * @returns
 */
export const logMaker = <E extends ExtraParams>(payload: NodeInvokeResult<E>): UpdateWorkflowLogPayload => {
    const { status, nodeStatus, workflowId, nodeId, workflowInstanceId, result, runtimeParams } = payload

    let extraInfo: { output?: NodePutData[][] } = {}

    if (result.type === 'args') {
        const args = getArgsResult(result)
        if (args) {
            extraInfo = {
                output: [
                    args.map(item => {
                        return {
                            label: item.name,
                            type: item.innerType,
                            value: item.value
                        }
                    })
                ] as NodePutData[][]
            }
        }
    }

    if (result.type === 'record') {
        const record = getRecordResult(result)
        if (record) {
            const { dsId, content } = record
            const { dataSourceList } = runtimeParams
            const dataSource = dataSourceList?.find(ds => ds.id === dsId)

            extraInfo = {
                output: content
                    ? ([
                          Object.entries(content)
                              .map(([key, value]) => {
                                  const field = dataSource?.schema[key]
                                  if (!field) {
                                      return undefined
                                  }
                                  return {
                                      label: field.name,
                                      type: field.innerType,
                                      value: value?.value
                                  }
                              })
                              .filter(Boolean)
                      ] as NodePutData[][])
                    : []
            }
        }
    }

    if (result.type === 'condition') {
        const output =
            result.success && result.data
                ? [
                      result.data.map<NodePutData>((filterResult, index) => ({
                          label: filterResult.name,
                          type: 'BOOL',
                          value: filterResult.isPass,
                          id: filterResult.id
                      }))
                  ]
                : []
        extraInfo = {
            output
        }
    }
    // const dsId = data?.data?.config && 'dsId' in data.data.config ? data.data.config.dsId : undefined

    return {
        workflowId,
        workflowInstanceId,
        status,
        nodeId,
        nodeStatus: {
            ...nodeStatus,
            input: [],
            output: extraInfo?.output || []
        }
    }
}
